module.exports = __webpack_public_path__ + "img/ellipse-draft.c99eeb54.svg";